// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root[data-theme='dark'] {
  --ui-canvas: #08141d;
  --ui-canvas-soft: #0d1b26;
  --ui-surface: #10202c;
  --ui-surface-soft: #132734;
  --ui-border: rgba(120, 163, 193, 0.26);
  --ui-border-strong: rgba(120, 163, 193, 0.36);
  --ui-text: #e6f2fb;
  --ui-text-soft: #a7c0d2;
  --ui-accent: #62afd9;
  --ui-accent-strong: #2f759f;
  --ui-success: #4fd198;
  --ui-warning: #e1b862;
  --ui-danger: #e78d80;
}

:root[data-theme='dark'] body {
  color: var(--ui-text);
  background:
    radial-gradient(circle at 84% 12%, rgba(98, 175, 217, 0.2), transparent 48%),
    radial-gradient(circle at 12% 84%, rgba(225, 184, 98, 0.16), transparent 44%),
    linear-gradient(180deg, #06111a 0%, #0a1822 100%);
}

:root[data-theme='dark'] .app-header,
:root[data-theme='dark'] .view-tabs,
:root[data-theme='dark'] .filters,
:root[data-theme='dark'] .summary-card,
:root[data-theme='dark'] .board,
:root[data-theme='dark'] .approved-view,
:root[data-theme='dark'] .tax-view,
:root[data-theme='dark'] .attendance-view,
:root[data-theme='dark'] .locations-panel,
:root[data-theme='dark'] .db-shortcuts-panel {
  background: linear-gradient(150deg, rgba(17, 35, 47, 0.96), rgba(13, 28, 39, 0.94));
  border-color: var(--ui-border);
  color: var(--ui-text);
}

:root[data-theme='dark'] .btn.ghost {
  color: #c6dded;
  border-color: rgba(130, 177, 208, 0.4);
}

:root[data-theme='dark'] .table-row,
:root[data-theme='dark'] .attendance-table-row,
:root[data-theme='dark'] .tax-table-row,
:root[data-theme='dark'] .approved-card,
:root[data-theme='dark'] .log-item {
  background: rgba(10, 24, 34, 0.72);
  border-color: rgba(115, 161, 192, 0.34);
}

:root[data-theme='dark'] .helper-text,
:root[data-theme='dark'] .subtitle {
  color: var(--ui-text-soft);
}

:root[data-theme='dark'] .auth-shell {
  background:
    radial-gradient(circle at 14% 8%, rgba(98, 175, 217, 0.2), transparent 42%),
    radial-gradient(circle at 86% 92%, rgba(79, 209, 152, 0.16), transparent 46%);
}

:root[data-theme='dark'] .login-card {
  background: linear-gradient(155deg, rgba(16, 35, 47, 0.97), rgba(11, 26, 37, 0.96));
  border-color: var(--ui-border);
  color: var(--ui-text);
}

:root[data-theme='dark'] .login-card input {
  background: rgba(8, 20, 29, 0.92);
  border-color: rgba(120, 163, 193, 0.38);
  color: var(--ui-text);
}

:root[data-theme='dark'] .login-card input:focus-visible {
  box-shadow: 0 0 0 3px rgba(98, 175, 217, 0.25);
}

:root[data-theme='dark'] .auth-footnote {
  border-top-color: rgba(120, 163, 193, 0.28);
  color: var(--ui-text-soft);
}
`, "",{"version":3,"sources":["webpack://./src/styles/themes.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;EAC1B,sCAAsC;EACtC,6CAA6C;EAC7C,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB;;;qDAGmD;AACrD;;AAEA;;;;;;;;;;EAUE,mFAAmF;EACnF,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,sCAAsC;AACxC;;AAEA;;;;;EAKE,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE;;iFAE+E;AACjF;;AAEA;EACE,mFAAmF;EACnF,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,2CAA2C;EAC3C,0BAA0B;AAC5B","sourcesContent":[":root[data-theme='dark'] {\n  --ui-canvas: #08141d;\n  --ui-canvas-soft: #0d1b26;\n  --ui-surface: #10202c;\n  --ui-surface-soft: #132734;\n  --ui-border: rgba(120, 163, 193, 0.26);\n  --ui-border-strong: rgba(120, 163, 193, 0.36);\n  --ui-text: #e6f2fb;\n  --ui-text-soft: #a7c0d2;\n  --ui-accent: #62afd9;\n  --ui-accent-strong: #2f759f;\n  --ui-success: #4fd198;\n  --ui-warning: #e1b862;\n  --ui-danger: #e78d80;\n}\n\n:root[data-theme='dark'] body {\n  color: var(--ui-text);\n  background:\n    radial-gradient(circle at 84% 12%, rgba(98, 175, 217, 0.2), transparent 48%),\n    radial-gradient(circle at 12% 84%, rgba(225, 184, 98, 0.16), transparent 44%),\n    linear-gradient(180deg, #06111a 0%, #0a1822 100%);\n}\n\n:root[data-theme='dark'] .app-header,\n:root[data-theme='dark'] .view-tabs,\n:root[data-theme='dark'] .filters,\n:root[data-theme='dark'] .summary-card,\n:root[data-theme='dark'] .board,\n:root[data-theme='dark'] .approved-view,\n:root[data-theme='dark'] .tax-view,\n:root[data-theme='dark'] .attendance-view,\n:root[data-theme='dark'] .locations-panel,\n:root[data-theme='dark'] .db-shortcuts-panel {\n  background: linear-gradient(150deg, rgba(17, 35, 47, 0.96), rgba(13, 28, 39, 0.94));\n  border-color: var(--ui-border);\n  color: var(--ui-text);\n}\n\n:root[data-theme='dark'] .btn.ghost {\n  color: #c6dded;\n  border-color: rgba(130, 177, 208, 0.4);\n}\n\n:root[data-theme='dark'] .table-row,\n:root[data-theme='dark'] .attendance-table-row,\n:root[data-theme='dark'] .tax-table-row,\n:root[data-theme='dark'] .approved-card,\n:root[data-theme='dark'] .log-item {\n  background: rgba(10, 24, 34, 0.72);\n  border-color: rgba(115, 161, 192, 0.34);\n}\n\n:root[data-theme='dark'] .helper-text,\n:root[data-theme='dark'] .subtitle {\n  color: var(--ui-text-soft);\n}\n\n:root[data-theme='dark'] .auth-shell {\n  background:\n    radial-gradient(circle at 14% 8%, rgba(98, 175, 217, 0.2), transparent 42%),\n    radial-gradient(circle at 86% 92%, rgba(79, 209, 152, 0.16), transparent 46%);\n}\n\n:root[data-theme='dark'] .login-card {\n  background: linear-gradient(155deg, rgba(16, 35, 47, 0.97), rgba(11, 26, 37, 0.96));\n  border-color: var(--ui-border);\n  color: var(--ui-text);\n}\n\n:root[data-theme='dark'] .login-card input {\n  background: rgba(8, 20, 29, 0.92);\n  border-color: rgba(120, 163, 193, 0.38);\n  color: var(--ui-text);\n}\n\n:root[data-theme='dark'] .login-card input:focus-visible {\n  box-shadow: 0 0 0 3px rgba(98, 175, 217, 0.25);\n}\n\n:root[data-theme='dark'] .auth-footnote {\n  border-top-color: rgba(120, 163, 193, 0.28);\n  color: var(--ui-text-soft);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
